import { colors } from "./color";

function scaleColorComponent(doubleHexValue:string, scalePercent:number):string{
    const doubleHexRegEx = new RegExp(/^([A-Fa-f0-9]{2})$/);
    if (doubleHexValue === null || doubleHexValue === undefined || typeof doubleHexValue !== 'string' || !doubleHexRegEx.test(doubleHexValue))
        throw new Error('invalid hex component (expected 2 digit hex component): ' + doubleHexValue);

    if(scalePercent < -100 || scalePercent > 100)
        throw new Error('invalid scalePercent');
    
    const numericValue = parseInt(doubleHexValue, 16);
    const scaleFactor = scalePercent / 100;

    let scaledValue = numericValue;
    if(scalePercent > 0)
        scaledValue = Math.round(numericValue + (255 - numericValue) * scaleFactor);
    else
        scaledValue = Math.round(numericValue * (1 - Math.abs(scaleFactor)));

    if(scaledValue < 16)
        return `0${scaledValue.toString(16)}`;

    return scaledValue.toString(16);
}

export function shadeOrTintRGBHexColor(inputHexColor:string, amountPercent:number)
{
    const regex = new RegExp(/^#([A-Fa-f0-9]{6})$/);
    if (inputHexColor === null || inputHexColor === undefined || typeof inputHexColor !== 'string' || !regex.test(inputHexColor))
        throw new Error('invalid inputHextColor (' + inputHexColor + '). Expected format #RRGGBB, eg. #FF22D4');
    
    const r = scaleColorComponent(inputHexColor.substring(1, 3), amountPercent);
    const g = scaleColorComponent(inputHexColor.substring(3, 5), amountPercent);
    const b = scaleColorComponent(inputHexColor.substring(5, 7), amountPercent);

    const newColor = `#${r}${g}${b}`;

    return newColor;
}

export function addAlphaToRGBHexColor(inputHexColor:string, alphaPercent:number)
{
    const regex = new RegExp(/^#([A-Fa-f0-9]{6})$/);
    if (inputHexColor === null || inputHexColor === undefined || typeof inputHexColor !== 'string' || !regex.test(inputHexColor))
        throw new Error('invalid inputHextColor (' + inputHexColor + '). Expected format #RRGGBB, eg. #FF22D4');

    const r = inputHexColor.substring(1, 3);
    const g = inputHexColor.substring(3, 5);
    const b = inputHexColor.substring(5, 7);
    const a = `${Math.round(255 * alphaPercent / 100).toString(16)}`

    const newColor = `#${r}${g}${b}${a}`;

    return newColor;
}


export function getIndexColors(index:number):{dark:string, light:string}
{
    return colors.newIndexed[index % colors.newIndexed.length];
}